import { ProtectorType } from 'core/constants';
import { AnswerTypes } from 'utils/api/modules/incidents/incidents.types';
import { UuidableName } from 'utils/api/types';

/** Mapping `.uuid` off a list yields `undefined`, which `JSON.stringify` drops from the PATCH; and
 * `[]` must become `null`, which the store and the server's required check read as unanswered. */
export const normalizeAnswerForSave = (type: ProtectorType, value: AnswerTypes): AnswerTypes => {
  if (type !== ProtectorType.User && type !== ProtectorType.Lookup) {
    return value;
  }

  if (Array.isArray(value)) {
    const uuids = (value as UuidableName[]).map((record) => record?.uuid).filter(Boolean);
    return uuids.length > 0 ? (uuids as AnswerTypes) : null;
  }

  return value ? (value as UuidableName).uuid : value;
};
